import script from "./OrdersCreditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersCreditPage.vue?vue&type=script&setup=true&lang=js"

import "./OrdersCreditPage.vue?vue&type=style&index=0&id=760a36b8&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-760a36b8"]])

export default __exports__